module.exports = __webpack_public_path__ + "fa425ed34159e055ab741b1b49e71272.pdf";